import Repository from '../../../Repository';

const resource = '/shopify';

export default {
  getOrder(region, orderId) {
    return Repository.get(`${resource}/orders/${orderId}`, {
      params: {
        region,
      },
    });
  },
  getOrderOCA(region, orderId) {
    return Repository.get(`/order-change-app/order/${orderId}`, {
      params: {
        region,
      },
    });
  },
  updateOrder(region, orderId, {order}) {
    return Repository.put(`${resource}/orders/${orderId}`, {
      region,
      order,
    });
  },
  cancelOrder(region, orderId) {
    return Repository.get(`${resource}/orders/${region}/${orderId}/cancel`);
  },
  calculateTaxes(region, {draft_order, original_order}) {
    return Repository.post(`${resource}/taxes`, {
      region,
      draft_order,
      original_order
    });
  },
};
